<!-- MODAL agregarredepositoCheque -->
<div mdbModal #agregarredeposito="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog" role="document">
        <form [formGroup]='formData' novalidate (ngSubmit)="guardar()">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="isEditing">
                        Agregar
                    </h4>
                    <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="!isEditing">
                        Ver
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="agregarredeposito.hide()">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div [ngClass]="{'modal-body':true, disabledContent: !isEditing}">
                    <div class="row">
                        <div class="col">
                            <h5 class="modal-title w-100 text-left" id="myModalLabel">
                                Datos de redepósito de cheque
                            </h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="max-width: 150px;">
                            <div class="md-form">
                                <input value="" type="text" id="rutcliente" class="form-control" placeholder=""
                                    required #rutcliente formControlName="rutCliente" formatRut />
                                <label for="rutcliente">RUT</label>
                                <div *ngIf="
                                          formData.get('rutCliente').invalid &&
                                          (formData.get('rutCliente').dirty ||
                                          formData.get('rutCliente').touched)
                                      ">
                                    <mdb-error *ngIf="formData.get('rutCliente').hasError('required')">
                                        Ingrese rut cliente
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col d-flex" style="max-width: 300px;">
                            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                                (click)="openModalSeleccionarClientes()" *ngIf="isEditing">
                                <mdb-icon fas icon="search"></mdb-icon>
                            </button>
                            <h6 class="text-info" style="display: contents;">
                                {{ clienteSeleccionado?.razon_social }}
                            </h6>
                        </div>
                    </div>
                    <div [ngClass]="{'row': true, disabledContent: !isEditing || !clienteSeleccionado}">
                        <div class="col" style="max-width: 150px;">
                            <div class="md-form">
                                <input value="" type="text" id="codpago" class="form-control" placeholder="99999"
                                    required #codpago formControlName="nroCheque" />
                                <label for="codpago">Cheque</label>
                                <div *ngIf="
                                        formData.get('nroCheque').invalid &&
                                        (formData.get('nroCheque').dirty ||
                                        formData.get('nroCheque').touched)
                                    ">
                                    <mdb-error *ngIf="formData.get('nroCheque').hasError('required')">
                                        Ingrese cheque
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col d-flex" style="max-width: 300px;">
                            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                                (click)="openModalSeleccionarProtesto()" *ngIf="isEditing">
                                <mdb-icon fas icon="search"></mdb-icon>
                            </button>
                            <h6 class="text-info" style="display: contents;">
                                {{ protestoSeleccionado?.nombre_banco }}
                            </h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="dato-form" *ngIf="isEditing">
                                <Strong class="title">Fecha protesto</Strong>
                                <span class="value" *ngIf="protestoSeleccionado && protestoSeleccionado.fecha_protesto">
                                    {{protestoSeleccionado.fecha_protesto | fecha}}
                                </span>
                                <span class="value" *ngIf="!protestoSeleccionado">&nbsp;</span>
                            </div>
                            <div class="dato-form" *ngIf="!isEditing">
                                <Strong class="title">Fecha ingreso</Strong>
                                <span class="value" *ngIf="protestoSeleccionado && protestoSeleccionado.fecha_registro">
                                    {{protestoSeleccionado.fecha_registro | fecha}}
                                </span>
                                <span class="value" *ngIf="!protestoSeleccionado">&nbsp;</span>
                            </div>
                            <div class="dato-form" *ngIf="!isEditing">
                                <Strong class="title">Fecha redepósito</Strong>
                                <span class="value"
                                    *ngIf="protestoSeleccionado && protestoSeleccionado.fecha">
                                    {{protestoSeleccionado.fecha | fecha}}
                                </span>
                                <span class="value" *ngIf="!protestoSeleccionado">&nbsp;</span>
                            </div>
                            <div class="md-form">
                                <input value="" type="text" id="motivo" class="form-control" placeholder="Motivo"
                                    required #motivo formControlName="motivo" />
                                <label for="motivo">Motivo</label>
                                <div *ngIf="
                                          formData.get('motivo').invalid &&
                                          (formData.get('motivo').dirty ||
                                          formData.get('motivo').touched)
                                      ">
                                    <mdb-error *ngIf="formData.get('motivo').hasError('required')">
                                        Ingrese motivo
                                    </mdb-error>
                                </div>
                            </div>
                            <!-- <div class="md-form" style="max-width: 200px;">
                                <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha registro'"
                                    required formControlName="fecha"></mdb-date-picker>
                                <div *ngIf="
                                      formData.get('fecha').invalid &&
                                      (formData.get('fecha').dirty ||
                                      formData.get('fecha').touched)
                                  ">
                                    <mdb-error *ngIf="formData.get('fecha').hasError('required')">
                                        Ingrese fecha
                                    </mdb-error>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                        (click)="cerrar()" mdbWavesEffect>
                        Cerrar
                    </button>
                    <button type="submit" class="btn btn-secondary waves-light" mdbWavesEffect *ngIf="isEditing">
                        Guardar
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT_BLO_DESB" (onSelectSingle)="onClienteSeleccionado($event)"
    (onNotFound)="onNotFoundCliente()">
</app-modal-seleccionar-cliente>

<!-- MODAL seleccionarCheque -->
<app-modal-seleccionar-protesto (onSelect)="onProtestoSeleccionado($event)" (onNotFound)="onNotFoundCheque()">
</app-modal-seleccionar-protesto>